'use es6';

import Layout from 'DesignData/models/layouts/Layout';
export default class LayoutBuffer extends Layout {
  constructor(props) {
    return super(props);
  }

}